<template>
    <div class="com-codics-hbb-order-admin-user-info-body">
        <div class="com-codics-hbb-order-admin-user-info-bar-content">
            <div class="com-codics-hbb-order-admin-user-info-bar-tag-box">
                <div class="com-codics-hbb-order-admin-user-info-bar-tag-item" v-for="(item, index) in tagData"
                    :style="{ '--nowIndex': nowIndex == index ? 'visible' : 'hidden' }" :key="index">
                    {{ item }}
                </div>
            </div>
            <div class="com-codics-hbb-order-admin-user-info-content">
                <div class="com-codics-hbb-order-admin-user-info-himg-box">
                    <div class="com-codics-hbb-order-admin-user-info-himg">
                        <el-upload action="cdn.bosscaigou.com" accept="*/image" :http-request="uploadHimg" :limit="1"
                            :show-file-list="false">
                            <img class="com-codics-hbb-order-admin-user-info-himg-upload-himg" :src="(userInfo?.user?.himg == '' || userInfo?.user?.himg == null)
                                ? 'https://cdn.bosscaigou.com/huayuan/img/yasuo_32885335124c023f36b0937fa76107a%20%281%29.webp'
                                : 'https://cdn.bosscaigou.com/' + userInfo?.user?.himg" alt="个人头像">
                            <div class="com-codics-hbb-order-admin-user-info-himg-upload-zz iconfont">&#xe70c;</div>
                        </el-upload>
                    </div>
                    <div class="com-codics-hbb-order-admin-user-info-himg-line"></div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line2">
                    </div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line3">
                    </div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line4">
                    </div>
                    <div class="com-codics-hbb-order-admin-user-info-himg-text">个人头像</div>
                </div>
                <div class="com-codics-hbb-order-admin-user-info-line">
                    <div class="com-codics-hbb-order-admin-user-info-line-text"><span
                            style="color: #798597;">姓名：</span>{{ userInfo?.user?.nickname }}&nbsp;&nbsp;&nbsp;<span
                            class="iconfont" style="font-size: 12px;cursor: pointer;user-select: none;color: #777;"
                            @click="nickDialog = true; nowNick = userInfo?.user?.nickname;">&#xe70c;
                            修改</span>&nbsp;&nbsp;&nbsp;<span class="iconfont"
                            style="font-size: 12px;cursor: pointer;user-select: none;color: red;" v-if="isName">&#xe999;
                            当前昵称为默认昵称，请及时修改为您的姓名，方便管理员识别您的身份！</span>
                    </div>
                    <div class="com-codics-hbb-order-admin-user-info-line-text"><span
                            style="color: #798597;">角色：</span><span style="color: #2E2F44;">{{
                            userInfo?.user?.role == null ? '未绑定' : userInfo?.user?.role?.role
                            }}</span>&nbsp;&nbsp;&nbsp;<span class="iconfont" v-show="userInfo?.user?.role == null"
                            style="font-size: 12px;color: red;cursor: pointer;user-select: none;">&#xe999;
                            您的账号尚未绑定角色，请耐心等待管理为您绑定角色或者点此联系管理！</span>
                    </div>
                    <div class="com-codics-hbb-order-admin-user-info-line-text"><span
                            style="color: #798597;">电话：</span><span style="color: #2E2F44;">{{
                            userInfo?.user?.phone == null ? '未绑定' : userInfo?.user?.phone
                            }}</span>&nbsp;&nbsp;&nbsp;<span class="iconfont"
                            style="font-size: 12px;color: red;cursor: pointer;user-select: none;"
                            @click="phoneDialog = true;">&#xe79c; 去绑定</span>
                    </div>
                    <div class="com-codics-hbb-order-admin-user-info-line-text"><span
                            style="color: #798597;">邮箱：</span><span style="color: #2E2F44;">{{
                            userInfo?.user?.email == null ? '未绑定' : userInfo?.user?.email
                            }}</span>&nbsp;&nbsp;&nbsp;<span class="iconfont"
                            style="font-size: 12px;color: red;cursor: pointer;user-select: none;">&#xe79c; 去绑定</span>
                    </div>
                </div>
                <div v-show="false"
                    class="com-codics-hbb-order-admin-user-info-himg-box com-codics-hbb-order-admin-user-info-himg-box2">
                    <div class="com-codics-hbb-order-admin-user-info-himg">
                        <img :src="'https://cdn.bosscaigou.com/huayuan/img/%E4%BA%8C%E7%BB%B4%E7%A0%81.png'"
                            alt="绑定微信二维码">
                    </div>
                    <div class="com-codics-hbb-order-admin-user-info-himg-line"></div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line2">
                    </div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line3">
                    </div>
                    <div
                        class="com-codics-hbb-order-admin-user-info-himg-line com-codics-hbb-order-admin-user-info-himg-line4">
                    </div>
                </div>
            </div>
        </div>
        <el-button type="warning" class="iconfont" style="width: 100%;margin-top: 10px;" plain
            @click="passVisible = true;">&#xe70c; 修改密码</el-button>
        <el-dialog title="修改密码" :close-on-click-modal='false' :visible.sync="passVisible" :append-to-body="true"
            :modal-append-to-body="false" width="80%">
            <el-form :model="updateForm">
                <el-form-item label="原密码" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.o" autocomplete="off" placeholder="请输入原密码..." clearable
                        :maxlength="30" show-password></el-input>
                </el-form-item>
                <el-form-item label="重复原密码" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.opass1" autocomplete="off" placeholder="请输入原密码..." clearable
                        :maxlength="30" show-password></el-input>
                </el-form-item>
                <el-form-item label="现密码" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.n" autocomplete="off" placeholder="请输入现密码..." clearable
                        :maxlength="30" show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="passVisible = false">取 消</el-button>
                <el-button type="primary" @click="updatePassFuc();">确 定</el-button>
            </div>
        </el-dialog>
        <MyDialog :visible.sync="nickDialog" title="修改昵称">
            <el-input clearable
                style="margin-bottom: 70px;width: calc(50% - 7.5px) !important;position: relative;float: left;box-sizing: border-box;margin-top: 20px;font-size: 10px !important;"
                v-model="nowNick" size="small" placeholder="请输入用户昵称"></el-input>
            <el-button type="success" style="position: absolute;margin: auto;right: 15px;bottom: 15px;" size="mini"
                @click="updateNickFuc">确认修改</el-button>
        </MyDialog>
        <MyDialog :visible.sync="phoneDialog" title="绑定手机号">
            <el-input clearable
                style="margin-bottom: 70px;width: calc(50% - 7.5px) !important;position: relative;float: left;box-sizing: border-box;margin-top: 20px;font-size: 10px !important;"
                v-model="nowPhone" size="small" placeholder="请输入要绑定的手机号"></el-input>
            <el-button type="success" style="position: absolute;margin: auto;right: 15px;bottom: 15px;" size="mini"
                @click="bindPhoneFuc">确认绑定</el-button>
        </MyDialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import { updateHimg, updateNick, updatePass, getQiNiuToken, bindPhone } from '@/api';
import * as qiniu from 'qiniu-js';
import { randomString } from '@/utils/myutils';
export default {
    data() {
        return {
            phoneDialog: false,
            nowPhone: '',
            nickDialog: false,
            nowNick: '',
            formLabelWidth: '110px',
            passVisible: false,
            nowIndex: 0,
            tagData: ['用户信息'],
            updateForm: {

            },
            qiNiuInfo: {
                token: null
            },
        }
    },
    components: {
        MyButton,
        MyDialog
    },
    mounted() {

        this.getTokenFuc();

    },
    computed: {
        ...mapState(['userInfo']),
        isName() {
            return this.userInfo?.user?.nickname.includes("用户_");
        }
    },
    methods: {
        async bindPhoneFuc() {
            const loading = this.$loading({
                lock: true,
                text: '绑定中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await bindPhone({ 'phone': this.nowPhone });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '绑定成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        async getTokenFuc() {
            let data = await getQiNiuToken();
            if (data.code == 200) {
                this.qiNiuInfo.token = data.uptoken;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        uploadHimg(uploadInfo) {

            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const _that = this;
            // 上传文件
            const observer2 = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)

                    _that.updateHimgFuc(res.key);

                    loading.close();

                }
            }
            // console.log(uploadInfo.file);
            const observable2 = qiniu.upload(uploadInfo.file, 'huayuan/img/' + randomString(10) + '_' + new Date().getTime() + '.png', this.qiNiuInfo.token, {}, {
            });

            const subscription2 = observable2.subscribe(observer2) // 上传开始
        },
        async updateHimgFuc(img) {
            if (img == '' || img == null) {
                this.$message({
                    message: '头像不能为空！',
                    type: 'warning'
                });
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await updateHimg({ 'img': img });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '更新头像成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async updateNickFuc() {
            if (this.nowNick == '') {
                this.$message({
                    message: '昵称不能为空！',
                    type: 'warning'
                });
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await updateNick({ 'name': this.nowNick });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '更新昵称成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
            this.nickDialog = false;
        },
        async updatePassFuc() {

            if (this.updateForm.o == '' || this.updateForm.opass1 == '' || this.updateForm.n == '') {

                this.$message({
                    message: '密码不能为空！',
                    type: 'warning'
                });

                return;

            }

            if (this.updateForm.o != this.updateForm.opass1) {
                this.$message({
                    message: '两次输入的密码不一致！',
                    type: 'warning'
                });
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await updatePass(this.updateForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '更新密码成功！',
                    type: 'success'
                });

                setTimeout(() => {
                    this.$store.dispatch("logout");
                    window.location.reload();
                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

            this.passVisible = false;

        },
    }
}
</script>

<style>
.com-codics-hbb-order-admin-user-info-body {
    height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
}

:root {
    --hbb-user-info-bar-l-color: #EEE;
}

:root[data-theme="dark"] {}

.com-codics-hbb-order-admin-user-info-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 0 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-user-info-bar-tag-box {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 40px;
    box-sizing: border-box;
    border-bottom: 1px solid var(--hbb-user-info-bar-l-color);
}

/* .com-codics-hbb-order-admin-user-info-bar-tag-box::before {
    content: "";
    height: 1px;
    width: calc();
    position: absolute;
    left: 0;
    top: 0;
    background: #EEE;
    background: var(--hbb-user-info-bar-l-color);
} */

.com-codics-hbb-order-admin-user-info-bar-tag-item {
    height: 40px;
    width: fit-content;
    position: relative;
    float: left;
    display: flex;
    box-sizing: border-box;
    padding: 0 20px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
    color: #333;
    transition: .3s;
    font-weight: bolder;
}

.com-codics-hbb-order-admin-user-info-bar-tag-item::before {
    content: "";
    height: 2px;
    width: calc(100% - 30px);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    background: #333;
    transition: .3s;
    border-radius: 1px;
}

.com-codics-hbb-order-admin-user-info-content {
    height: 205px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 15px 10px;
}

.com-codics-hbb-order-admin-user-info-himg {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 20px;
    border: 1px solid #333;
    overflow: hidden;
}

.com-codics-hbb-order-admin-user-info-himg img {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-hbb-order-admin-user-info-himg-text {
    height: 20px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    box-sizing: border-box;
    line-height: 20px;
    font-size: 12px;
    font-weight: bolder;
    color: #333;
    text-align: center;
}

.com-codics-hbb-order-admin-user-info-himg-box {
    height: 100%;
    width: 175px;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-left: 1px solid #DDD;
    padding: 30px;
}

.com-codics-hbb-order-admin-user-info-himg-box::before,
.com-codics-hbb-order-admin-user-info-himg-box::after {
    content: "";
    height: 1px;
    width: 10px;
    position: absolute;
    margin: auto;
    left: -5px;
    top: 0;
    background: #DDD;
}

.com-codics-hbb-order-admin-user-info-himg-box::after {
    top: unset;
    bottom: 0;
}

.com-codics-hbb-order-admin-user-info-himg-box2 {
    border-left: unset !important;
    cursor: pointer;
}

.com-codics-hbb-order-admin-user-info-himg-box2::before,
.com-codics-hbb-order-admin-user-info-himg-box2::after {
    content: '扫描二维码绑定微信';
    height: 30px;
    width: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: -5px;
    line-height: 30px;
    font-size: 12px;
    color: #333;
    background: unset;
    text-align: center;
    font-weight: bolder;
}

.com-codics-hbb-order-admin-user-info-himg-box2::after {
    content: '鼠标点击刷新二维码';
    top: unset;
    bottom: 0px;
    color: #777;
    font-size: 10px;
}

.com-codics-hbb-order-admin-user-info-line {
    height: 100%;
    width: calc(100% - 350px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 7.5px 0px 7.5px 30px;
    border-right: 1px solid #333;
}

.com-codics-hbb-order-admin-user-info-line::before {
    content: '';
    height: calc(100% - 20px);
    width: 1px;
    position: absolute;
    margin: auto;
    right: -1px;
    top: 0;
    bottom: 0;
    background: #EEE;
}

.com-codics-hbb-order-admin-user-info-line-text {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 40px;
    font-size: 12px;
    color: #333;
    font-weight: bolder;
}

.com-codics-hbb-order-admin-user-info-himg-line {
    height: 1px;
    width: 90px;
    position: absolute;
    margin: auto;
    top: 30px;
    left: 0;
    right: 0;
    background: #EEE;
}

.com-codics-hbb-order-admin-user-info-himg-line2 {
    top: 144px !important;
}

.com-codics-hbb-order-admin-user-info-himg-line3 {
    width: 1px;
    height: 90px;
    right: auto;
    left: 30px;
    top: 0;
    bottom: 0;
}

.com-codics-hbb-order-admin-user-info-himg-line4 {
    width: 1px;
    height: 90px;
    right: 30px;
    left: auto;
    top: 0;
    bottom: 0;
}

.com-codics-hbb-order-admin-user-info-himg-upload-zz {
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, .4);
    z-index: 1000;
    opacity: 0;
    transition: .3s;
    font-size: 14px;
    color: #FFF;
    text-align: center;
    line-height: 113px;
    backdrop-filter: blur(5px);
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
}

.com-codics-hbb-order-admin-user-info-himg-upload-zz:hover {
    opacity: 1;
}
</style>